import logo from './logo.svg';
import './App.css';
import RoutesGame from './routingGame/routingGame';
import Header from './components/header/header';

function App() {
  return (
    <>
      <Header />
      <RoutesGame />
    </>
  );
}

export default App;
